import { useAuth0 } from '@auth0/auth0-react'
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import {
  getAllProjectsByUserAdmin,
  getProjectResumenData,
  getSingleProjectByUserAdmin,
  updateImageProject,
  updateProjectResumenData,
  updateSingleProjectByUserAdmin,
  createFormProject,
  changeUserRole,
} from 'api/projectApi'
import toast from 'react-hot-toast'

export const useGetAllProjectsByUserAdmin = (email, options) => {
  return useQuery({
    queryKey: ['projects-admin', email, options],
    queryFn: () => getAllProjectsByUserAdmin(options),
  })
}

export const useGetSingleProjectByUserAdmin = (
  email,
  idProject,
  enabled = true
) => {
  return useQuery({
    queryKey: ['project-admin', idProject, email],
    queryFn: () => getSingleProjectByUserAdmin(idProject),
    enabled: enabled,
  })
}

/*Crear FormCreateProyecto*/

export const useCreateFormProject = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: createFormProject, // Aquí se utiliza la función definida arriba
    onSuccess: () => {
      toast.success('Proyecto creado correctamente')
      queryClient.invalidateQueries(['projects-admin'])
    },
    onError: error => {
      console.error('Error en la creación del proyecto:', error) // Log de error para depuración
      toast.error('Error al crear el proyecto')
    },
  })
}

export const useUpdateSingleProjectByUserAdmin = (email, idProject) => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: ({ body }) => updateSingleProjectByUserAdmin(idProject, body),

    onSuccess: () => {
      toast.success('Proyecto actualizado correctamente', {
        id: 'project-updated',
      })
      queryClient.invalidateQueries(['projects-admin', email])
      queryClient.invalidateQueries(['project-admin', idProject, email])
    },
    onError: () => {
      toast.error('Error al actualizar el proyecto')
    },
  })
}

export const useUpdateImageProject = (idProject, onSuccess) => {
  const queryClient = useQueryClient()
  let toastId

  return useMutation({
    mutationFn: dataurl => updateImageProject(idProject, dataurl),
    onMutate: () => {
      toastId = toast.loading('Actualizando imagen del proyecto...')
    },
    onSuccess: () => {
      toast.dismiss(toastId)
      onSuccess()
      toast.success('Imagen actualizada correctamente')
      queryClient.invalidateQueries(['projects-admin'])
      queryClient.invalidateQueries(['project-admin', idProject])
    },
    onError: () => {
      toast.dismiss(toastId)
      toast.error('Error al actualizar la imagen')
    },
  })
}

export const useGetProjectResumenData = (idProject, enabled) => {
  return useQuery({
    queryKey: ['project-resumen', idProject],
    queryFn: () => getProjectResumenData(idProject),
    enabled: enabled,
  })
}

export const useUpdateProjectResumenData = (idProject, enabled) => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: data => updateProjectResumenData(idProject, data),

    onSuccess: () => {
      queryClient.invalidateQueries(['project-resumen'])
      queryClient.invalidateQueries(['project-resumen', idProject])
    },
    onError: () => {},
  })
}

export const useChangeUserRole = () => {
  const queryClient = useQueryClient()
  const { user } = useAuth0()

  return useMutation({
    mutationFn: changeUserRole,
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries([
        'project-admin',
        variables.proyectoId,
        user.sub,
      ])
      toast.success('Rol cambiado correctamente')
    },
    onError: () => {
      toast.error('Error al cambiar el rol')
    },
  })
}
